import { Typography } from '@mui/material';
import { EMPTY_VALUE } from 'shared/constants';
import { Currencies } from 'shared/types';
import { formatCurrency } from 'shared/utils';
import BudgetTypography from '../components/BudgetTypography/BudgetTypography';
import formatNumberOrDash from '../../../../../../services/excelExport/helpers/formatNumberOrDash';

export const renderBudgetCell = (
  value: number | null,
  rowColor: string,
  currency: Currencies,
  exchangeRate?: number
): JSX.Element | string => {
  const budget = value;

  return (
    <BudgetTypography color={rowColor} value={formatNumberOrDash(budget)} />
  );
};
